import React from 'react'
import styles from './style.module.scss'
import track from '@assets/images/f1/img/track.png'
import Image from 'next/future/image'
import PropTypes from 'prop-types'
import CustomLink from '@shared/components/customLink'

const UpcomingEvent = ({ upcoming }) => {
  const schedule = getFormattedSchedule(upcoming)
  return (
    <div className={`${styles.widget} position-relative`} key={upcoming?.nRound}>
      {upcoming?.oCircuit?.sArticleUrl && <EventHeader upcoming={upcoming} />}
      <EventDetails upcoming={upcoming} />
      <TrackImage upcoming={upcoming} />
      <ScheduleList schedule={schedule} />
    </div>
  )
}

const EventHeader = ({ upcoming }) => (
  <CustomLink href={upcoming?.oCircuit?.sArticleUrl}>
    <a className="position-absolute top-0 start-0 w-100 h-100 opacity-0">{`Round ${upcoming?.round}`}</a>
  </CustomLink>
)
EventHeader.propTypes = {
  upcoming: PropTypes.object
}

const EventDetails = ({ upcoming }) => (
  <div className={styles.eventDetails}>
    <span className={styles.round}>{`Up Next Round ${upcoming?.round}`}</span>
    <div className="d-flex flex-row gap-2">
      <span className={styles.line}></span>
      <h3 className={styles.country}>{upcoming?.oCircuit?.oLocation?.sCountry}</h3>
    </div>
    <p className={styles.about}>
      {`${upcoming?.raceName}. Get ready for the thrill of Formula 1 2025 as the world's fastest drivers take on this iconic circuit in the upcoming Grand Prix!`}
    </p>
  </div>
)
EventDetails.propTypes = {
  upcoming: PropTypes.object
}
const TrackImage = ({ upcoming }) => (
  <div className={styles.track}>
    <Image src={upcoming?.oCircuit?.sImgUrl || track} alt="Track Image" width={301} height={172} />
  </div>
)
TrackImage.propTypes = {
  upcoming: PropTypes.object
}
const ScheduleList = ({ schedule }) => (
  <div className={styles.schedule}>
    {schedule?.map((info, i) => (
      <ScheduleItem key={i} info={info} />
    ))}
  </div>
)
ScheduleList.propTypes = {
  schedule: PropTypes.array
}
const ScheduleItem = ({ info }) => {
  const sessionColorClass = info?.session === 'Qualifying' || info?.session === 'Race' ? styles.highlight : ''
  return (
    <div className="d-flex flex-row justify-content-between">
      <span className={`${styles.space} text-start ${sessionColorClass}`}>{info?.session}</span>
      <span className={`${styles.space} text-center`}>{info?.day}</span>
      <span className={`${styles.space} text-end`}>{`${info?.startTime} - ${info?.endTime}`}</span>
    </div>
  )
}
ScheduleItem.propTypes = {
  info: PropTypes.object
}
const getFormattedSchedule = circuit => {
  const sessions = [
    { key: 'firstPracticeDate', session: 'First Practice' },
    { key: 'secondPracticeDate', session: 'Second Practice' },
    { key: 'thirdPracticeDate', session: 'Third Practice' },
    { key: 'qualifyingDate', session: 'Qualifying' },
    { key: 'date', session: 'Race' }
  ]
  return sessions.reduce((acc, { key, session }) => {
    const rawStart = circuit?.[key]
    if (!rawStart) return acc
    const startDate = new Date(rawStart)
    const day = startDate.toLocaleDateString('en-US', { weekday: 'short' })
    const startTime = startDate.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    })
    const endDate = new Date(startDate.getTime() + 60 * 60 * 1000)
    const endTime = endDate.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    })
    acc.push({ session, day, startTime, endTime })
    return acc
  }, [])
}

UpcomingEvent.propTypes = {
  upcoming: PropTypes.object
}

export default UpcomingEvent
